var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClimate = function SvgClimate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be5267cc-e312-4a6a-9f0c-bac7f9076b0a",
    "data-name": "Layer 29",
    viewBox: "0 0 54.29 109",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bf38ec25-7e80-4f00-9292-b43f3143b5c7",
    "data-name": "Temp Focused"
  }, /*#__PURE__*/React.createElement("path", {
    className: "efce7ac3-cd95-4f3d-961d-9832fd876594",
    d: "M100.3,60V15.81a15.27,15.27,0,1,0-30.54,0V60a27.15,27.15,0,1,0,30.54,0ZM85,104.45a22,22,0,0,1-11.4-40.9,2.53,2.53,0,0,0,1.22-2.17V15.81a10.18,10.18,0,1,1,20.36,0V61.38a2.52,2.52,0,0,0,1.23,2.17A22,22,0,0,1,85,104.45Z",
    transform: "translate(-57.89 -0.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "efce7ac3-cd95-4f3d-961d-9832fd876594",
    d: "M87.58,70.8v-30a2.55,2.55,0,0,0-5.09,0v30a12.09,12.09,0,1,0,5.09,0ZM85,89.61a7,7,0,0,1-1.15-13.88,2.29,2.29,0,0,0,2.3,0A7,7,0,0,1,85,89.61Z",
    transform: "translate(-57.89 -0.54)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClimate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/climate.a85629ad.svg";
export { ForwardRef as ReactComponent };